import './Services.css'

const Services = () => {
    return (
        <div>
            <div className="services">
                <h3>AMENITIES & SERVICES</h3>
                <div className="services-cards">
                    <div className="services-card">
                        <img src="./HomePhotos/Services/1.jpg" alt="services" />
                        <p>GYM</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/2.jpg" alt="services" />
                        <p>COFFEE SHOP</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/3.jpg" alt="services" />
                        <p>SAUNA</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/4.jpg" alt="services" />
                        <p>24/7 ELECRICITY</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/5.jpg" alt="services" />
                        <p>PARK ON ALL SIDES</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/6.jpg" alt="services" />
                        <p>SMART ELEVATOR</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/7.jpg" alt="services" />
                        <p>SMART APPARTMENTS</p>
                    </div>
                    <div className="services-card">
                        <img src="./HomePhotos/Services/8.png" alt="services" />
                        <p>GATED COMMUNITY</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services